import React from "react";

import { LineProps } from "./types";
import { useLine } from "./hooks";

export const Line = (props: LineProps) => {
  const { getLineProps } = useLine(props);
  return <div {...getLineProps()}>{props.line}</div>;
};
